import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {WS_READ_MODEL_UPDATED, WsReadModelUpdatedAction, WS_MEIN_DIENSTPLAN, WsMeinDienstplanAction} from '../../websocket.actions';
import {filter, flatMap, map, withLatestFrom} from 'rxjs/operators';
import {IncidentsEntityTypes} from '../../../client-constants';
import INCIDENT_ENTITY = IncidentsEntityTypes.INCIDENT_ENTITY;
import {GetIncidentDetailAction, GetMeineIncidents2Action} from '../../../client-ngrx/incidents';
import {IncidentDetail, IncidentKopf} from '../../../clients/incidents';
import {getSelectedIncident} from './meine-aufgaben.selectors';
import {getSelectedVeranstaltungsIds} from '../incident-leitzentrale/incident-leitzentrale.selectors';

@Injectable()
export class MeineAufgabenPageWsEffects {

    @Effect()
    wsUpdateListen$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === INCIDENT_ENTITY;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <IncidentDetail> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getSelectedVeranstaltungsIds)))
        , filter(([x, ids]: [IncidentDetail, string[]]) => {
            return ids !== null && ids !== undefined; // && ids.findIndex((id) => id === x.veranstaltung_id) > -1;
        })
        , flatMap(([x, ids]: [IncidentDetail, string[]]) =>
            [   new GetMeineIncidents2Action(ids)]
        )
    );

    @Effect()
    wsUpdateListenDienstplan$: Observable<Action> = this.actions$.pipe(
        ofType<WsMeinDienstplanAction>(WS_MEIN_DIENSTPLAN)
        , withLatestFrom(this.store.pipe(select(getSelectedVeranstaltungsIds)))
        , filter(([, ids]) => {
            return ids !== null && ids !== undefined; // && ids.findIndex((id) => id === x.message.veranstaltung_id) > -1;
        })
        , flatMap(([x, ids]) =>
            [   new GetMeineIncidents2Action(ids)]
        )
    );

    @Effect()
    wsUpdateDetail$: Observable<Action> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED)
        , filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === INCIDENT_ENTITY;
        })
        , map((x: WsReadModelUpdatedAction) => {
            return <IncidentKopf> JSON.parse(x.message.entity);
        })
        , withLatestFrom(this.store.pipe(select(getSelectedIncident)))
        , filter(([x, selectedIncident]: [IncidentKopf, IncidentKopf]) => {
            return selectedIncident !== null && selectedIncident !== undefined && selectedIncident.incident_id === x.incident_id;
        })
        , map(([, selectedIncident]: [IncidentKopf, IncidentKopf]) => {
            return new GetIncidentDetailAction(selectedIncident.incident_id);
        })
    );

    constructor(
        private actions$: Actions,
        private store: Store<any>,
    ) {
    }
}
